import { Patient } from '@/types/appointments.types';
import { Dependent } from '@/types/auth-base.types';

const wordNotToCapitalize = ['da', 'de', 'do', 'das', 'dos'];

export const formatToTitleCase = (text: string = '') => {
  const words = text.split(' ');
  const titleCaseWords = words.map((word) => {
    if (wordNotToCapitalize.includes(word.toLowerCase())) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return titleCaseWords.join(' ');
};

export const formatClientName = (patient: Patient | Dependent) => {
  return formatToTitleCase(patient.socialName || patient.legalName);
};
